export const OPTIONS = [20, 50, 100];
